module.exports = __webpack_public_path__ + "img/scope-education.902906d9.png";